import { render, staticRenderFns } from "./PermissionSave.vue?vue&type=template&id=02658a39&"
import script from "./PermissionSave.vue?vue&type=script&lang=js&"
export * from "./PermissionSave.vue?vue&type=script&lang=js&"
import style0 from "./PermissionSave.vue?vue&type=style&index=0&id=02658a39&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports